import React from 'react';
import type { FC } from 'react';
import type { DevMetadata } from '@wix/cli-astro-definitions';
import { useSiteConfig } from '../../model.js';
import { DevEnvironmentProvider } from './DevEnvironment.js';
import { SiteDev } from './site-flow/SiteDev.js';

interface SiteDevFlowProps {
  serverLocalUrl: string;
  serverExposedUrl?: string;
  devMetadata: DevMetadata | null;
}

export const SiteDevFlow: FC<SiteDevFlowProps> = (props) => {
  const { siteId } = useSiteConfig();

  return (
    <DevEnvironmentProvider {...props} siteId={siteId}>
      <SiteDev />
    </DevEnvironmentProvider>
  );
};
